const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const isEmailValid = value => value.length > 0 && EMAIL_REGEX.test(value);

export default isEmailValid;
